import { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "components/common/ProtectedRoute";
import DefaultView from "components/common/DefaultView";
import Main from "components/views/main/Main";
import NotFound from "components/views/NotFound";
import Login from "components/views/Login";
import Visitors from "components/views/Visitors";
import DropAPin from "components/views/DropAPin";

// const Main = lazy(() =>
//   import(/* webpackPrefetch: true */ "components/views/main/Main")
// );
// const NotFound = lazy(() => import("components/views/NotFound"));
// const Login = lazy(() => import("components/views/Login"));
// const Visitors = lazy(() => import("components/views/Visitors.js"));
// const DropAPin = lazy(() => import('components/views/DropAPin.js'));
// [hygen] Import views

export const ROUTE_PATHS = {
  LOGIN: "/login",
  DEFAULT: "/",
  NOT_FOUND: "404",
  VISITORS: "/visitors",
  DROP_A_PIN: "/drop-a-pin",
  // [hygen] Add path routes
};

const routes = [
  {
    path: ROUTE_PATHS.DEFAULT,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <Main />
        </DefaultView>
      </ProtectedRoute>
    ),
    children: [
      { path: "/", element: <Navigate to="/visitors" /> },
      { path: ROUTE_PATHS.VISITORS, element: <Visitors /> },
      { path: ROUTE_PATHS.DROP_A_PIN, element: <DropAPin /> },
      // [hygen] Add routes
    ],
  },
  { path: ROUTE_PATHS.LOGIN, element: <Login /> },
  {
    path: ROUTE_PATHS.NOT_FOUND,
    element: (
      <DefaultView>
        <NotFound />
      </DefaultView>
    ),
  },
  { path: "*", element: <Navigate to={ROUTE_PATHS.NOT_FOUND} /> },
];

export default routes;
